import React from 'react';
import Dialog from '#lib/components/dialog.jsx';
import Input from '#lib/components/input.jsx';
import { AddRowButton } from '../@itinerary/planner/row.jsx';
import { formatHour } from '#@itinerary/planner/helpers.js';
import { NoSymbolIcon, XMarkIcon } from '@heroicons/react/24/solid';
import Button from '#lib/components/button.jsx';
import { useOpeningHours } from '#@itinerary/places/use-opening-hours.js';

export function HoursModal(props) {
    const { isOpen, onClose, openingHours, suggestionData, onChange } = props;

    const { hours, editHours, addPeriod, deletePeriod, discardChanges } = useOpeningHours({
        initialData: openingHours
    });
    const weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    if (!hours) return null;
    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="flex flex-col space-y-6 min-w-[500px] min-h-[300px] max-h-[80%] mt-20 overflow-auto">
                <div className="pr-4">
                    <Dialog.CloseButton
                        onClick={() => {
                            discardChanges();
                            onClose();
                        }}
                    />
                    <b>{_t.edit.filters.openingHours()}</b>
                </div>

                <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7 gap-4">
                    {weekDays?.map((dayName, dayIndex) => {
                        const day = hours.find((day) => day.day === dayName);
                        return (
                            <div
                                className="col-span-1"
                                key={dayIndex}
                                style={{
                                    display: 'grid',
                                    gridTemplateRows:
                                        day.periods.length === 2 ? `30px repeat(2, 75px)` : `30px 1fr 30px`,
                                    alignItems: 'start',
                                    gap: '1.5rem'
                                }}
                            >
                                <span className="row-span-1 pb-2 font-semibold border-b border-b-neutral-300">
                                    {dayName}
                                </span>
                                {day?.periods.length > 0 ? (
                                    day?.periods.map((period, idx) => (
                                        <div key={idx} className="flex gap-x-1 items-center">
                                            <div className="row-span-1 w-full flex-col space-y-1 items-center">
                                                <div className="flex gap-x-1 items-center justify-between w-full h-1/2">
                                                    <span className="text-xs">OPEN: </span>
                                                    <Input.Full
                                                        value={formatHour(period?.open) || ''}
                                                        name="open"
                                                        type="time"
                                                        onChange={(e) =>
                                                            editHours(dayName, idx, 'open', e.target.value)
                                                        }
                                                    />
                                                </div>
                                                <div className="flex gap-x-1 items-center justify-between w-full h-1/2">
                                                    <span className="text-xs">CLOSE: </span>
                                                    <Input.Full
                                                        value={formatHour(period?.close) || ''}
                                                        name="close"
                                                        type="time"
                                                        onChange={(e) =>
                                                            editHours(dayName, idx, 'close', e.target.value)
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <Button
                                                className="h-[85px] bg-neutral-100 rounded hover:bg-neutral-300"
                                                onClick={() => deletePeriod(dayName, idx)}
                                            >
                                                <XMarkIcon className="icon-sm" />
                                            </Button>
                                        </div>
                                    ))
                                ) : (
                                    <div className="w-full h-[85px] p-2 bg-neutral-100 rounded-lg flex flex-col space-y-1 justify-center items-center row-span-1">
                                        <span className="font-semibold">CLOSED</span>
                                        <NoSymbolIcon className="icon-sm" />
                                    </div>
                                )}
                                {day?.periods.length < 2 && (
                                    <div className="row-span-1 w-full h-full">
                                        <AddRowButton onClick={() => addPeriod(dayName)} />
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
                <div className="w-full flex justify-end gap-4">
                    <Button onClick={discardChanges}>{_t.global.cancel()}</Button>
                    <Button
                        look="primary"
                        onClick={(e) => {
                            onChange(e, hours);
                            onClose();
                        }}
                    >
                        {_t.global.confirm()}
                    </Button>
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
